export const ANALYTICS_PREFIX = 'BenefitsStudio';

const COMMON_BASE = `${ANALYTICS_PREFIX}.Common`;
const COMMON_EVENTS = {
    serviceUnavailable: `${COMMON_BASE}.ServiceUnavailable`,
    serviceAvailabilityRestored: `${COMMON_BASE}.ServiceAvailabilityRestored`,
    refreshFailedRequest: `${COMMON_BASE}.RefreshFailedRequest`,
    termsOfUseAccepted: `${COMMON_BASE}.TermsOfUseAccepted`,
    accessGranted: `${COMMON_BASE}.AccessGranted`
};

export const ANALYTICS_EVENTS = {
    common: COMMON_EVENTS
};
